if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      loadProductFirst: true,
      numberFilterTree: 2,
      selectOptionContainer: '.grid__item .card-wrapper',
      stickyFixTopPos: true
    },
    selector: {
      otpTopCartCount: '.cart-count-bubble'
    }
  };
}

(function () {
  var onSale = false,
  discountExclude = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];

  BoostPFS.inject(this);
  /* For Filter Setting Layout */
  Selector.stickyElementDesktop =
    jQ('.boost-pfs-filter-left-col').length > 0 && !Utils.isMobile()
      ? '.boost-pfs-filter-left-col'
      : '.boost-pfs-filter-tree';
  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    var saleClass = onSale ? boostPFSTemplate.saleClass : '';
    var ratioImage = getRatioImage(data);
    var imageAspectRatio = (ratioImage / getAspectRatio(data.images_info[0])) * 100;

    itemHtml = itemHtml.replace(/{{imageAspectRatio}}/g, imageAspectRatio);

    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add Card product class
    itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass(data));
    // Add Card inner product class
    itemHtml = itemHtml.replace(/{{cardInnerProductClass}}/g, buildCardInnerProductClass(data));
    // Add Card badge position
    itemHtml = itemHtml.replace(/{{cardBadgePosition}}/g, boostPFSThemeConfig.custom.badge_position);
    // Add check card heading five
    itemHtml = itemHtml.replace(/{{cardIsHeadingFive}}/g, buildCardIsHeadingFive(data));
    // Add sold out Label
    itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

    // Add sale Label
    itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
    // Add new Label
    itemHtml = itemHtml.replace(/{{itemNew}}/g, buildNewLabel(data));
    // Add sale site wide message
    itemHtml = itemHtml.replace(/{{saleSiteWideMessage}}/g, buildSaleSiteWideMessage());
    // Add product dimension
    itemHtml = itemHtml.replace(/{{itemDimension}}/g, buildProductDimension(data));

    // Add QuickAdd Button
    itemHtml = itemHtml.replace(/{{quickAdd}}/g, buildQuickAdd(data));

    // Add Review
    if (
      typeof Integration === 'undefined' ||
      (typeof Integration != 'undefined' &&
        typeof Integration.hascompileTemplate == 'function' &&
        !Integration.hascompileTemplate('reviews'))
    ) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    // Add Description
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, boostPFSThemeConfig.custom.description || '');

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    data.skus[0]
      ? (itemHtml = itemHtml.replace(/{{itemSku}}/g, data.skus[0]))
      : (itemHtml = itemHtml.replace(/{{itemSku}}/g, ''));
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildImages(data) {
    var html = '';
    if (images && Array.isArray(images) && images.length > 0) {
      html += '<div class="card__media">';
      var aspectRatio = '',
        rangeWidths = boostPFSRangeWidths;

      var dataSrcSet = '',
        imgAlt = data.title,
        flipImageSrcSet = '';

      var activeSwapImage =
        !Utils.isMobile() &&
        images.length > 1 &&
        boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
        boostPFSThemeConfig.custom.show_secondary_image == true;

      for (var i = 0; i < rangeWidths.length; i++) {
        dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

        if (activeSwapImage) {
          flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
        }

        if (i < rangeWidths.length - 1) {
          dataSrcSet += ', ';

          if (activeSwapImage) {
            flipImageSrcSet += ', ';
          }
        }
      }

      aspectRatio = images[0]['width'] / images[0]['height'];
      html +=
        '<div class="img-wrapper"><img class="motion-reduce"' +
        'loading="lazy"' +
        'srcset="' +
        dataSrcSet +
        '" ' +
        'height="' +
        images[0].height +
        '" ' +
        'width="' +
        images[0].width +
        '" ' +
        'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
        'src="' +
        Utils.optimizeImage(images[0].src, '533x') +
        '" ' +
        'alt="' +
        imgAlt +
        '" />';

      if (activeSwapImage) {
        html +=
          '<img class="motion-reduce"' +
          'loading="lazy"' +
          'srcset="' +
          flipImageSrcSet +
          '" ' +
          'height="' +
          images[1].height +
          '" ' +
          'width="' +
          images[1].width +
          '" ' +
          'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
          'src="' +
          Utils.optimizeImage(images[1].src, '533x') +
          '" ' +
          'alt="' +
          imgAlt +
          '" />';
      }
      html += '</div>';
      html += '</div>';
    } else {
      html += `<div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading">
                    <a href="#" class="full-unstyled-link">
                      ${data.title}
                    </a>
                  </h3>
                </div>
              </div>`;
    }
    return html;
  }

  function buildCardProductClass(data) {
    var html = '' + boostPFSThemeConfig.custom.card_style;
    if (!images) {
      html += ' card--text';
    } else {
      html += ' card--media';
    }
    if (boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (!images && boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardInnerProductClass(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardIsHeadingFive(data) {
    var html = '';
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html = 'h5';
    }
    return html;
  }

  function buildVendor(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') && boostPFSThemeConfig.custom.show_vendor === true) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }

  function buildPrice(data) {
    var html = '';
    var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
    var priceAmount = boostPFSConfig.custom.currency_code_enabled
      ? Utils.formatMoney(data.price_min, 'money_with_currency')
      : Utils.formatMoney(data.price_min);
    var compareAtPrice = boostPFSConfig.custom.currency_code_enabled
      ? Utils.formatMoney(data.compare_at_price_min, 'money_with_currency')
      : Utils.formatMoney(data.compare_at_price_min);
    var moneyPrice = priceVaries
      ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount)
      : priceAmount;
    var unitPriceClass =
      !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined'
        ? 'hidden'
        : '';

    /*** Prepare Sale data ***/

    var custom_sale = false;
    var collection_sale = false;
    var tuesday_sale = false;
    var friday_sale = false;
    var tuesday_sale_set = window.sale.tuesday_sale_set;
    var friday_sale_set = window.sale.friday_sale_set;
    var site_wide = window.sale.site_wide;
    var site_wide_message = window.sale.site_wide_message;
    var no_discount = false;
    var tuesday_percent_off = window.sale.tuesday_percent_off;
    var friday_percent_off = window.sale.friday_percent_off;
    var sale_collection = window.sale.sale_collection;

    var reg_sale = false;
    if (data.compare_at_price_min > data.price_min) {
      reg_sale = true;
    }

    if (!reg_sale) {
      // Collection Sale
      var sale_col_arr = sale_collection;
      var saleDisc = [];
      var sale_col_e_arr = [];
      var col_percent_off = 0;
      for (var i = 0; i < sale_col_arr.length; i++) {
        var sale_col_split = sale_col_arr[i].split('|');
        var col_handle = sale_col_split[0];
        var col_enable = sale_col_split[1];
        var col_discount = sale_col_split[2];
        var current_tags = data['tags'];
        if (col_handle != '' && col_enable == 'true' && col_discount != '') {
          sale_col_e_arr.push(col_handle + '|' + col_discount);
        }
      }
      var current_tags = data['tags'];

      if (current_tags.indexOf('nodiscount') !== -1) {
        no_discount = true;
      }

      current_tags = current_tags.map(function (e) {
        return e.toLowerCase();
      });
      for (var j = 0; j < sale_col_e_arr.length; j++) {
        var sale_col_split_next = sale_col_e_arr[j].split('|');
        var req_tag = sale_col_split_next[0];
        if (current_tags.indexOf(req_tag) !== -1) {
          collection_sale = true;
          custom_sale = true;
          col_percent_off = sale_col_split_next[1];
          col_percent_off = 1.0 - col_percent_off / 100.0;
          saleDisc.push(col_percent_off.toFixed(2));
          //break;
        }
      }

      // Tuesday Sale
      if (tuesday_sale_set) {
        var tuesday_tag = window.sale.tuesday_tag;
        for (var i = 0; i < data['tags'].length; i++) {
          var tagI = data['tags'][i].toLowerCase();
          if (tagI == tuesday_tag) {
            tuesday_sale = true;
            custom_sale = true;
            saleDisc.push(tuesday_percent_off.toFixed(2));
            break;
          }
        }
      }

      //Friday Sale
      if (friday_sale_set) {
        var friday_tag = window.sale.friday_tag;
        for (var i = 0; i < data['tags'].length; i++) {
          var tagI = data['tags'][i].toLowerCase();
          if (tagI == friday_tag) {
            friday_sale = true;
            custom_sale = true;
            saleDisc.push(friday_percent_off.toFixed(2));
            break;
          }
        }
      }
    }

    var images = data.images_info;
    (data.price_min *= 100),
      (data.price_max *= 100),
      (data.compare_at_price_min *= 100),
      (data.compare_at_price_max *= 100); // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    if (custom_sale) {
      onSale = true; // Check a product is on sale
    }
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }

    if (data['tags'].includes('discount-exclude')) {
      custom_sale = false;
      discountExclude = true;
      console.log('typeof ' + compareAtPrice);
      if (compareAtPrice.includes("&#36;0")) {
        compareAtPrice = "";
      }
      onSale = false;
    }

    if (custom_sale) {
      saleDisc.sort(function (a, b) {
        return a - b;
      });
      var percent_off = saleDisc[0];
      let discounted_p = Math.round(data.price_min * percent_off);
      let discounted_p_tx = discounted_p + '';
      discounted_p = +(discounted_p / 100).toFixed(2);
      compareAtPrice = moneyPrice;
      if (boostPFSConfig.custom.currency_code_enabled) {
        moneyPrice = `${Utils.getCurrency()}${discounted_p}${Shopify.currency.active}`;
      } else {
        moneyPrice = `${Utils.getCurrency()}${discounted_p}`;
      }
    }
    /*** End Prepare Sale data ***/

    html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${
      noComparePrice ? 'price--no-compare' : ''
    }">
          <div class="price__container">
            <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span class="price-item price-item--regular">
                ${moneyPrice}
              </span>
            </div>
            <div class="price__sale">
              <span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
              <span class="price-item price-item--sale">
                ${moneyPrice}
              </span>
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span>
                <s class="price-item price-item--regular price-item--last">
                  ${compareAtPrice}
                </s>
              </span>
            </div>
            <small class="unit-price caption ${unitPriceClass}">
              <span class="visually-hidden">${boostPFSConfig.label.unit_price}</span>
              <span class="price-item price-item--last">
                <span>${Utils.formatMoney(
                  data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price
                )}</span>
                <span aria-hidden="true">/</span>
                <span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
              </span>
            </small>
          </div>
        </div>`;
    return html;
  }

  function buildSoldOutLabel() {
    // Build Sold out label
    var soldOutLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(
        /{{soldOutBadgeClass}}/g,
        boostPFSThemeConfig.custom.sold_out_badge_color_scheme
      );
    }
    return soldOutLabel;
  }

  function buildSaleLabel() {
    // Build Sale label
    var saleLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(
        /{{saleBadgeClass}}/g,
        boostPFSThemeConfig.custom.sale_badge_color_scheme
      );
    }
    return saleLabel;
  }

  function buildNewLabel(data) {
    var isNew = false;
    if (data.collections) {
      for (var k = 0; k < data.collections.length; k++) {
        if (data['collections'][k].handle.indexOf('new') != -1) {
          isNew = true;
          break;
        }
      }
    }
    // Build New label
    var newLabel = '';
    if (isNew && !soldOut) {
      newLabel = boostPFSTemplate.newLabelHtml;
    }
    return newLabel;
  }

  function buildSaleSiteWideMessage() {
    // Build Sale Site Wide Message
    var saleSiteWideMessage = '';
    if (!onSale && discountExclude == false && window.sale.site_wide) {
      saleSiteWideMessage = boostPFSTemplate.saleSiteWideMessageHtml;
    }
    return saleSiteWideMessage;
  }

  function buildProductDimension(data) {
    // Build Product Dimension HTML
    const variant = data.selected_or_first_available_variant;
    const meta_specs = Utils.getProductMetafield(data, 'wood', 'specs');
    const meta_length_text = Utils.getProductMetafield(data, 'wood', 'length_text');
    const meta_width_text = Utils.getProductMetafield(data, 'wood', 'width_text');
    const meta_thickness_text = Utils.getProductMetafield(data, 'wood', 'thickness_text');
    const meta_length = Utils.getProductMetafield(data, 'wood', 'length');
    const meta_width = Utils.getProductMetafield(data, 'wood', 'width');
    const meta_thickness = Utils.getProductMetafield(data, 'wood', 'thickness');

    let html = '';
    let length = '';
    let width = '';
    let thickness = '';
    let itemLength = '';
    let itemWidth = '';
    let itemThickness = '';
    //convert data weight grams to pound
    let weight_pound = data.weight_min / 453.6;
    //round to 1 decimal place
    let weight_rounded = (Math.round(weight_pound * 10) / 10).toFixed(1);
    const variant_weight = data?.variants[0]?.weight ? parseFloat(data?.variants[0]?.weight).toFixed(1) : null;

    if (meta_length) {
      length = meta_length.replace('"', '') + '"';
      let itemMetafield = meta_length.replace('"', '');
      let itemFraction = '';
      let itemSplit = '';
      let itemWholeInch = '';
      let itemDimension = '';
      let itemLengthHalf = '';

      if (itemMetafield.indexOf('-') != -1 || itemMetafield.indexOf(' ') != -1) {
        if (itemMetafield.indexOf('-') != -1) {
          itemSplit = itemMetafield.split('-');
        } else if (itemMetafield.indexOf(' ') != -1) {
          itemSplit = itemMetafield.split(' ');
        }
        itemWholeInch = itemSplit[0] * 1;
        itemFraction = itemSplit[itemSplit.length - 1];
      } else if (itemMetafield.indexOf('/') != -1) {
        itemWholeInch = 0;
        itemFraction = itemFraction;
      } else {
        itemWholeInch = itemMetafield;
      }

      if (itemFraction != '') {
        let itemFractionSplit = itemFraction.split('/');
        let itemFractionTop = itemFractionSplit[0] * 1.0;
        let itemFractionBottom = itemFractionSplit[itemFractionSplit.length - 1] * 1.0;
        let itemDecimal = (itemFractionTop / itemFractionBottom) * 1.0;
        itemDimension = (itemWholeInch + itemDecimal) * 1.0;
      } else {
        itemDimension = itemWholeInch;
      }
      itemLength = itemDimension;
    }

    if (meta_width) {
      width += meta_width.replace('"', '') + '"';
      let itemMetafield = meta_width.replace('"', '');
      let itemFraction = '';
      let itemSplit = '';
      let itemWholeInch = '';
      let itemDimension = '';
      let itemLengthHalf = '';

      if (itemMetafield.indexOf('-') != -1 || itemMetafield.indexOf(' ') != -1) {
        if (itemMetafield.indexOf('-') != -1) {
          itemSplit = itemMetafield.split('-');
        } else if (itemMetafield.indexOf(' ') != -1) {
          itemSplit = itemMetafield.split(' ');
        }
        itemWholeInch = itemSplit[0] * 1;
        itemFraction = itemSplit[itemSplit.length - 1];
      } else if (itemMetafield.indexOf('/') != -1) {
        itemWholeInch = 0;
        itemFraction = itemFraction;
      } else {
        itemWholeInch = itemMetafield;
      }

      if (itemFraction != '') {
        let itemFractionSplit = itemFraction.split('/');
        let itemFractionTop = itemFractionSplit[0] * 1.0;
        let itemFractionBottom = itemFractionSplit[itemFractionSplit.length - 1] * 1.0;
        let itemDecimal = (itemFractionTop / itemFractionBottom) * 1.0;
        itemDimension = (itemWholeInch + itemDecimal) * 1.0;
      } else {
        itemDimension = itemWholeInch;
      }
      itemWidth = itemDimension;
    }

    if (meta_thickness) {
      thickness += meta_thickness.replace('"', '') + '"';
      let itemMetafield = meta_thickness.replace('"', '');
      let itemFraction = '';
      let itemSplit = '';
      let itemWholeInch = '';
      let itemDimension = '';
      let itemLengthHalf = '';

      if (itemMetafield.indexOf('-') != -1 || itemMetafield.indexOf(' ') != -1) {
        if (itemMetafield.indexOf('-') != -1) {
          itemSplit = itemMetafield.split('-');
        } else if (itemMetafield.indexOf(' ') != -1) {
          itemSplit = itemMetafield.split(' ');
        }
        itemWholeInch = itemSplit[0] * 1;
        itemFraction = itemSplit[itemSplit.length - 1];
      } else if (itemMetafield.indexOf('/') != -1) {
        itemWholeInch = 0;
        itemFraction = itemFraction;
      } else {
        itemWholeInch = itemMetafield;
      }

      if (itemFraction != '') {
        let itemFractionSplit = itemFraction.split('/');
        let itemFractionTop = itemFractionSplit[0] * 1.0;
        let itemFractionBottom = itemFractionSplit[itemFractionSplit.length - 1] * 1.0;
        let itemDecimal = (itemFractionTop / itemFractionBottom) * 1.0;
        itemDimension = (itemWholeInch + itemDecimal) * 1.0;
      } else {
        itemDimension = itemWholeInch;
      }
      itemThickness = itemDimension;
    }

    const length_text = meta_length_text ? ' ' + meta_length_text : '';
    const width_text = meta_width_text ? ' ' + meta_width_text : '';
    const thickness_text = meta_thickness_text ? ' ' + meta_thickness_text : '';
    // const weight_text = weight_rounded ? weight_rounded + ' lb' : '';
    const weight_text = variant_weight ? variant_weight + ' lb' : '';

    let dimensions = length + length_text + ' x ' + width + width_text + ' x ' + thickness + thickness_text;
    dimensions = meta_specs ? meta_specs : dimensions;

    let dividerHTML = '';
    let weightHTML = '';
    if (dimensions != '' || meta_specs != '') {
      weightHTML = `<span class="weight">${weight_text}</span>`;
      dividerHTML = '<span class="divider">|</span>';
    }

    html = '';

    if (weight_rounded != 'NaN') {
      html = `<div class="product__dimension">
      ${weightHTML}
      ${dividerHTML}
    <span class="dimensions">${dimensions}</span>
     </div>`;
    }
    return html;
  }

  function buildQuickAdd(data) {
    var html = '';

    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }

    html = `<div class="quick-add">
    <modal-opener data-modal="#QuickAdd-${data.id}">
      <button
        id="${data.id}-submit"
        type="submit"
        name="add"
        class="quick-add__submit button button--full-width button--secondary"
        aria-haspopup="dialog"
        aria-labelledby="${data.id}-submit"
        data-product-url="/products/${data.handle}"
      >
        ${window.cartStrings.quickView}
        <div class="loading-overlay__spinner hidden">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
      </button>
    </modal-opener>
    <quick-add-modal id="QuickAdd-${data.id}" class="quick-add-modal">
      <div role="dialog" aria-modal="true" class="quick-add-modal__content global-settings-popup" tabindex="-1">
        <button id="ModalClose-${data.id}" type="button" class="quick-add-modal__toggle" aria-label="Close">${window.icons.close}</button>
        <div id="QuickAddInfo-${data.id}" class="quick-add-modal__content-info">
        </div>
      </div>
    </quick-add-modal>
    </div>`;
    return html;
  }

  function buildReview(data) {
    var html = '';
    if (
      boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
      boostPFSThemeConfig.custom.show_product_review == true &&
      Utils.getProductMetafield(data, 'reviews', 'rating') !== null
    ) {
      var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >= 0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info
        .replace('{{ rating_value }}', ratingObj.value)
        .replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${
                  boostPFSConfig.custom.accent_icons
                }" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${
        ratingObj.value.scale_max
      }; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(data, 'reviews', 'rating_count')})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(data, 'reviews', 'rating_count')} ${
        boostPFSConfig.label.total_reviews
      }</span>
              </p>`;
    }
    return html;
  }

  function getAspectRatio(data) {
    var width = data == null ? '535' : data.width;
    var height = data == null ? '535' : data.height;

    return width / height;
  }

  function getRatioImage(data) {
    var ratio = 1;
    if (images && boostPFSThemeConfig.custom.media_size == 'portrait') {
      ratio = 0.8;
    } else if (images && boostPFSThemeConfig.custom.media_size == 'adapt') {
      ratio = getAspectRatio(data.images[0]);
    }
    if (ratio === 0 || ratio === null) {
      ratio = 1;
    }
    return ratio;
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = boostPFSTemplate.previousActiveHtml;
    let prevUrl = '';
    if (currentPage > 1) {
      prevUrl = ' href="' + Utils.buildToolbarLink('page', currentPage, currentPage - 1) + '" ';
    } else {
      prevUrl = ' aria-disabled="true" ';
    }
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, prevUrl);
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = boostPFSTemplate.nextActiveHtml;
    let nextUrl = '';
    if (currentPage == totalPage) {
      nextUrl = ' aria-disabled="true" ';
    } else {
      nextUrl = ' href="' + Utils.buildToolbarLink('page', currentPage, currentPage + 1) + '" ';
    }
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, nextUrl);
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml +=
          pageArr[iPage] == currentPage ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink('page', currentPage, pageArr[iPage])
      );
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || '';
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          var isSelected = '';
          if (paramSort == k) {
            isSelected = 'selected="selected"';
          }
          sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate());

    if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
      jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
    }

    var labelSort = '';
    var paramSort = Globals.queryParams.sort || '';
    var sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting;
    }

    jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    jQ(Selector.topSorting + ' .facet-filters__sort').change(function (e) {
      e.preventDefault();
      FilterApi.setParam('sort', jQ(this).val());
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
    });
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;
  };

  // Build Additional Elements
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
  };

  /************************** END BUILD TOOLBAR **************************/
})();
